import axios from 'axios';

const BASE_URL = `${window.__RUNTIME_CONFIG__?.REACT_APP_AUTH_SERVICE}/users`;

const getUsers = async () => axios.get(`${BASE_URL}/`);

const getUser = async (userId) => axios.get(`${BASE_URL}/${userId}`);

const updateUser = async (userData) =>
  axios.put(`${BASE_URL}/update`, { ...userData });

const deleteUser = async (userId) => axios.delete(`${BASE_URL}/${userId}`);

const deleteUsers = async (userIds) =>
  axios.delete(`${BASE_URL}?userIds=${userIds}`);

export { getUsers, getUser, deleteUser, updateUser, deleteUsers };
